<mat-toolbar color="accent">ACC Claim Request Details</mat-toolbar>

<div class="flex flex-col gap-4 bg-gray-50 p-4">
  <div class="flex items-center justify-between">
    <div
      class="bg-primary-50 text-primary-700 flex w-36 flex-col rounded-md px-2 py-1"
    >
      <span class="font-bold">Claim Number</span>
      <span class="text-base">{{
        data.claimRequest.data.claimData.claimNumber
      }}</span>
    </div>
    <div class="flex w-36 flex-col rounded-md p-2" [ngClass]="statusClasses">
      <span class="font-bold">Status</span>
      <span class="text-base">
        {{ data.claimRequest.status | titlecase }}
      </span>
    </div>
  </div>

  <pr-acc-claim-details-display
    *ngIf="data.claimRequest.data.claimData as claimData"
    [claimData]="claimData"
  />
</div>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
